import { render, staticRenderFns } from "./TemplateRegister.vue?vue&type=template&id=a5b02aba&scoped=true&lang=pug"
import script from "./TemplateRegister.vue?vue&type=script&lang=ts"
export * from "./TemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./TemplateRegister.vue?vue&type=style&index=0&id=a5b02aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b02aba",
  null
  
)

export default component.exports